module.exports = __webpack_public_path__ + "img/capacitor-surprise.7194fa6c.jpg";